import { ComponentProps, ReactElement } from 'react';

import Table from '@/common/Table';
import { getClasses } from '@/utils';

export type InvoiceTableHeaderProps = Omit<ComponentProps<typeof Table.Row>, 'header'> & {
  showCrewId: boolean;
  hasDiscounts: number;
};
const InvoicePdfTableHeader = ({ showCrewId, hasDiscounts, ...props }: InvoiceTableHeaderProps): ReactElement => {
  return (
    <Table.Row {...props} header className={getClasses('InvoicePdf-TableHeader', props.className)}>
      <Table.Cell className="INDEX">#</Table.Cell>
      <Table.Cell className="TYPE">Type</Table.Cell>
      <Table.Cell className="DATE">Date</Table.Cell>
      <Table.Cell className="SCHEDULED">Sched</Table.Cell>
      {!!hasDiscounts && <Table.Cell className="CURB_TIME">Curb</Table.Cell>}
      <Table.Cell className="CITY">City</Table.Cell>
      <Table.Cell className="AIRLINE">Al</Table.Cell>
      <Table.Cell className="FLIGHT_NUMBER">Flt</Table.Cell>
      <Table.Cell className="PILOTS">Plt</Table.Cell>
      <Table.Cell className="ATTENDANTS">Fa</Table.Cell>
      {showCrewId && <Table.Cell className="CREW_ID">Crew ID</Table.Cell>}
      <Table.Cell className="PICKUP_LOCATION">Pickup</Table.Cell>
      <Table.Cell className="DROPOFF_LOCATION">Dropoff</Table.Cell>
      {!!hasDiscounts && <Table.Cell className="SAVINGS">Savings</Table.Cell>}
      <Table.Cell className="RATE">Rate</Table.Cell>
    </Table.Row>
  );
};

export default InvoicePdfTableHeader;
